import Routes from './Routes';

function entityRoute(entity) {
  // eslint-disable-next-line
  if (!entity || !entity._type) {
    return undefined;
  }

  // eslint-disable-next-line
  switch (entity._type) {
    case 'Customer': {
      return Routes.customers.view({ id: entity.id });
    }

    case 'Resource': {
      return Routes.resources.view({ id: entity.id });
    }

    default:
      return undefined;
  }
}

export default entityRoute;
